export const locale = {
    lang: 'zh1',
    data: {
      'MODALES': {
        'ERROR_DATOS':'發生錯誤 A-721',
        'VALIDACION':{
          'ERROR1':'您有沒有翻譯的問題',
          'WARNING-SIN-TRADUCCION':'請添加您的試劑翻譯',
          'MODAL-GUARDANDO':'保存無功'
        },
        'TITULO': '發生錯誤',
        'TITULOS': {
          'error': '發生錯誤',
          'adver': '警告',
          'aviso': '警告',
          'opSuc': '動作完成'
        },
        'ACCIONES': {
          'aceptar' : '確認',
          'cancelar': '取消',
          'INFORMATIVO': '不要再顯示此消息'
        },
        'MENSAJES': {
          'NO_FECH_LAN':'數據不全，選擇產品發布日期',
          'NO_RESU_ACTI':'目前沒有結果，請稍後再試',
          'OK':'行',
          'Something is wrong': '發生問題',
          'password wrong': '密碼不正確',
          'User does not exist': '您輸入的電子郵件未在CultureGO中註冊',
          '150': '已保存',
          // 'Error: user already exist': 'El usuario que intenta registrar ya existe en CulturalGO',
          'CONEX': {
            'SIN': '您的設備失去了互聯網連接\n\n要繼續使用平台，請將您的設備連接到互聯網',
            'CON': '您的設備已恢復互聯網連接\n\n現在您可以繼續使用平台'
          },
          'WIZARD': {
            'CERTIFICAR' : {
              'RESTRICCIONES': {
                'rest1': '要訪問此部分，必須把調研設置為<b>語言</ b>。',
                'rest2': '要訪問此部分，必須完成前面所有步驟。',
                'rest3': '要訪問此部分，必須<b>安排</ b>啟動調研。',
                'rest4': '要訪問此部分，您必須完成<b>郵件發送</ b>，並已啟動調研。',
                // 'rest5': 'Para acceder a esta sección es necesario que configure los <b>Demográficos</b> para la encuesta.'
              },
              'IDIOMAS': {
                'NADA': '您尚未選擇語言',
                'NODEFAULT': '您尚未選擇主要語言',
                'NOADICIONAL': '您尚未選擇任何其他語言',
                'COMPLETAR': '您確定使用當前語言來完成此步驟嗎？',
                '210': '此步驟已完成',
                'COMPLETADO': '您已完成此步驟',
                'RESTRICCION': '完成此步驟後，將無法執行此操作',
                'INFORMATIVO': '在本部分中，您將選擇調查的主要語言和其他語言，以呈現給合作者。',
                'ARCHIVOCOMFIRM':'警告！ 一定要在单个操作系统上使用Excel文件，以避免编码冲突。',
                'BOTONTEXTO':'明白了',
              },
              'TEMPLATE': {
                // 'NADA': 'Aún no ha realizado la selección de los idiomas principal y adicionales',
                // 'NODEFAULT': 'Aún no ha seleccionado el idioma principal',
                // 'NOADICIONAL': 'Aún no ha seleccionado idiomas adicionales',
                // 'COMPLETAR': '¿Está seguro de completar el paso con la selección actual de idiomas?',
                // '210': 'El paso se completó correctamente',
                // 'COMPLETADO': 'Ya ha completado este paso',
                // 'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': '在本部分中，您可以更改模板',
                // 'ARCHIVOCOMFIRM':'¡Advertencia! Asegúrate de trabajar el archivo de Excel en un único sistema operativo para evitar conflictos de codificación',
                // 'BOTONTEXTO':'Enterado',

                // 'TITULO_DESBLOQUEAR': '<span>¿Está seguro de reabrir el paso de idiomas, tenga en cuenta que esto <font color="red">reiniciará</font> su producto actual y borrará toda la información que haya agregado a las secciones?</span>',
                // 'BOTON_CONFIRM': 'Sí, reabrir',
                // 'BOTON_CANCEL': 'Cancelar',
                // 'SUCCES': 'El paso ha sido reabierto con éxito',
                // 'BLOQUEADO': 'El paso ya esta abierto',
                // 'CERRAR': 'Cerrar'
              },
              'NPS': {
                'NADA': '您尚未創建任何NPS或將選項標記為沒有NPS',
                'COMPLETAR': '您確定可以使用當前的NPS完成此步驟嗎？',
                '219': '該步驟已成功完成',
                '220': '該步驟已成功完成',
                'COMPLETADO': '您已經完成了此步驟',
                'RESTRICCION': '完成此步驟後，將無法執行此操作',
                'INFORMATIVO': '在本部分中，您可以修改調查的NPS',
                'FALTANTES_TRADUCCIONES': '您尚未完成所有問題的翻譯填寫',
                'FALTANTES_SECCIONES_ESPECIALES': '你還沒有輸入特殊部分的鍵',
                'FALTANTES_RESPUESTAS': '您還無法完成此步驟，所有多項選擇題都必須至少有兩個答案選項',
                'SIN_PREGUNTAS': '您需要添加至少一個問題才能完成此步驟',
                'SIN_GRUPOS': '您需要添加至少一個包含一個問題的問題組才能完成該步驟',
                'FALTANTES': '您尚未填寫NPS'
              },
              'REACTIVOS': {
                'NADA': '您尚未創建任何反應堆，也未標記沒有反應堆的選項',
                'COMPLETAR': '您確定將當前反應堆標記為已完成嗎？',
                '218': '該步驟已成功完成',
                'COMPLETADO': '您已經完成了此步驟',
                'RESTRICCION': '完成此步驟後，將無法執行此操作',
                'INFORMATIVO': '在此部分中，您可以將反應性添加到調查中。',
                'FALTANTES_TRADUCCIONES': '您尚未完成所有問題的翻譯填寫',
                'FALTANTES_SECCIONES_ESPECIALES': '你還沒有輸入特殊部分的鍵',
                'FALTANTES_RESPUESTAS': '您還無法完成此步驟，所有多項選擇題都必須至少有兩個答案選項',
                'SIN_PREGUNTAS': '您需要添加至少一個問題才能完成此步驟',
                'SIN_GRUPOS': '您需要添加至少一個包含一個問題的問題組才能完成該步驟',
                'FALTANTES': '您尚未完成試劑的填充'
              },
              'FORALL': {
                'NADA': '您尚未完成4ALL練習的填寫',
                'COMPLETAR': '您確定將當前的4ALL Practice 來完成此步驟嗎？',
                '212': '此步驟已完成',
                'COMPLETADO': '您已完成此步驟',
                'RESTRICCION': '完成此步驟後，將無法執行此操作',
                'INFORMATIVO': '本節列出了公司中進行的活動，其中涉及所有合作者的參與。',
                'FALTANTES_TRADUCCIONES': '您尚未完成所有問題的翻譯填寫',
                'FALTANTES_SECCIONES_ESPECIALES': '你還沒有輸入特殊部分的鍵',
                'FALTANTES_RESPUESTAS': '您還無法完成此步驟，所有多項選擇題都必須至少有兩個答案選項',
                'SIN_PREGUNTAS': '您需要添加至少一個問題才能完成此步驟',
                'SIN_GRUPOS': '您需要添加至少一個包含一個問題的問題組才能完成該步驟',
                'NADA_TRA':'您尚未完成4ALL練習的翻譯'
              },
              'CONTROL': {
                'NADA': '您尚未創建任何控制問題或將選項標記為無控制',
                'COMPLETAR': '您確定要完成當前控制問題的步驟嗎？',
                '221': '此步驟已完成',
                'COMPLETADO': '您已完成此步驟',
                'RESTRICCION': '完成此步驟後，將無法執行此操作',
                'INFORMATIVO': '在此部分中，您可以修改調查控制問題',
                'FALTANTES_TRADUCCIONES': '您尚未完成所有問題的翻譯填寫',
                'FALTANTES_SECCIONES_ESPECIALES': '你還沒有輸入特殊部分的鍵',
                'FALTANTES_RESPUESTAS': '您還無法完成此步驟，所有多項選擇題都必須至少有兩個答案選項',
                'SIN_PREGUNTAS': '您需要添加至少一個問題才能完成此步驟',
                'SIN_GRUPOS': '您需要添加至少一個包含一個問題的問題組才能完成該步驟',
                'FALTANTES': '您尚未完成填寫控制問題'
              },
              'DEMOGRAFICOS': {
                'NADA': '您尚未選擇受眾特徵',
                'COMPLETAR': '您確定使用當前的人口統計信息來完成此步驟嗎？',
                '213': '此步驟已成功完成',
                'COMPLETADO': '您已完成此步驟',
                'RESTRICCION': '完成此步驟後，將無法執行此操作',
                'FALTANTES_TRADUCCIONES': '您尚未完成所有問題的翻譯填寫',
                'FALTANTES_SECCIONES_ESPECIALES': '你還沒有輸入特殊部分的鍵',
                'FALTANTES_RESPUESTAS': '您還無法完成此步驟，所有多項選擇題都必須至少有兩個答案選項',
                'SIN_PREGUNTAS': '您需要添加至少一個問題才能完成此步驟',
                'SIN_GRUPOS': '您需要添加至少一個包含一個問題的問題組才能完成該步驟',
                'INFORMATIVO': '本部分建立了人口統計選項，可供調查中的合作者使用。'
              },
              'ABIERTAS': {
                'NADA': '您尚未創建任何未解決的問題，也未將該選項標記為未解決的問題',
                'COMPLETAR': '您確定將當前未解決的問題標記為已完成嗎？',
                '220': '該步驟已成功完成',
                '219': '該步驟已成功完成',
                'COMPLETADO': '您已經完成了此步驟',
                'RESTRICCION': '完成此步驟後，將無法執行此操作',
                'INFORMATIVO': '在此部分中，您可以向調查中添加未解決的問題',
                'FALTANTES_TRADUCCIONES': '您尚未完成所有問題的翻譯填寫',
                'FALTANTES_SECCIONES_ESPECIALES': '你還沒有輸入特殊部分的鍵',
                'FALTANTES_RESPUESTAS': '您還無法完成此步驟，所有多項選擇題都必須至少有兩個答案選項',
                'SIN_PREGUNTAS': '您需要添加至少一個問題才能完成此步驟',
                'SIN_GRUPOS': '您需要添加至少一個包含一個問題的問題組才能完成該步驟',
                'FALTANTES': '您尚未完成填寫未解決的問題'
              },
              'ADICIONALES': {
                'NADA': '您尚未新增任何其他問題，或選擇任何其他問題的選項',
                'COMPLETAR': '您確定使用當前的其他問題來完成此步驟嗎？',
                '214': '此步驟已完成',
                'COMPLETADO': '您已完成此步驟',
                'RESTRICCION': '完成此步驟後，將無法執行此操作',
                'FALTANTES_TRADUCCIONES': '您尚未完成所有問題的翻譯填寫',
                'FALTANTES_SECCIONES_ESPECIALES': '你還沒有輸入特殊部分的鍵',
                'FALTANTES_RESPUESTAS': '您還無法完成此步驟，所有多項選擇題都必須至少有兩個答案選項',
                'SIN_PREGUNTAS': '您需要添加至少一個問題才能完成此步驟',
                'SIN_GRUPOS': '您需要添加至少一個包含一個問題的問題組才能完成該步驟',
                'INFORMATIVO': '在本部分中，您可以向調查添加自定義問題。'
              },
              'COLABORADORES': {
                'NADA': '他尚未將合作者的信息上傳到CULTURALGO®。',
                'COMPLETAR': '您確定使用當前的員工資料庫來完成此步驟嗎？',
                '211': '此步驟已完成',
                'COMPLETADO': '您已完成此步驟',
                'RESTRICCION': '完成此步驟後，將無法執行此操作',
                'INFORMATIVO': '此部分加載將通過電子郵件向其發送調查邀請的協作者列表。',
                'ACTUALIZAR': '協作者已正確添加到調查中'
              },
              'PROGRAMACION': {
                'NADA': '您尚未安排日期',
                'COMPLETAR': '您確定使用當前計劃日期來完成此步驟嗎？',
                'GENERAR': '您確定把此步驟標示為已完成嗎？',
                '215': '此步驟已完成',
                '217': '此步驟已完成', //CERTIFICAR2.0
                'COMPLETADO': '您已完成此步驟',
                'FECHALANZAMIENTO': '您尚未輸入發布日期',
                'RESTRICCION': '完成此步驟後，將無法執行此操作',
                'INFORMATIVO': '本節確定了啟動和發送調查完成提醒的日期。',
                'INFORMATIVO2':'本部分設置發送調查的日期脈衝檢查 ',
                'GUARDA-OK':'日期已成功保存',
                'OK':'好',
                'NOT_MESS_COM':'不允許使用此功能',
                'DETEC_CAMBIOS_SECCIONES':'在部分的配置中檢測到更改，再次生成調查',
              },
              'ENVIO': {
                'NADA': '您尚未完成發送給協作者的調查邀請電子郵件',
                'NADA_OPCION': '您尚未配置是否通過電子郵件發送邀請',
                'COMPLETAR': '您確定把此步驟標示為已完成嗎？',
                '216': '此步驟已完成',
                'COMPLETADO': '您已完成此步驟',
                'RESTRICCION': '完成此步驟後，將無法執行此操作',
                'INFORMATIVO': '在此部分中，完成調查完成邀請發送。'
              },
              'CONFIRMACION': {
                // 'NADA': 'Aún no ha realizado el envío de la invitación a la encuesta a sus colaboradores',
                // 'NADA_OPCION': 'Aún no ha configurado si el envío de la invitación se hará por correo electrónico',
                // 'COMPLETAR': '¿Está seguro de completar el paso?',
                // '216': 'El paso se completó correctamente',
                // 'COMPLETADO': 'Ya ha completado este paso',
                // 'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                 'INFORMATIVO': '在此部分中，您可以激活或停用調查',
                // 'TITULO_DESBLOQUEAR': '¿Está seguro de reabrir el paso de envío de correos?',
                // 'BOTON_CONFIRM': 'Sí, reabrir',
                // 'BOTON_CANCEL': 'Cancelar',
                // 'SUCCES': 'El paso ha sido reabierto con éxito',
                // 'BLOQUEADO': 'El paso ya esta abierto',
                // 'CERRAR': 'Cerrar'
              },
              'CIERRE': {
                'NADA': '調查尚未完成。',
                'COMPLETAR': '您確定將此步驟標示為已完成嗎？',
                '217': '此步驟已完成',
                'COMPLETADO': '您已完成此步驟',
                'RESTRICCION': '完成此步驟後，將無法執行此操作',
                'INFORMATIVO': '在本節中，可以查詢當前的調查進度以及調查的早日結束。',
                'INFORMATIVO2':'在此部分中，您可以檢查啟動的每個Pulse Check調查的當前進度 '
              }
            },
            'NOM35': {
              'CENTROS': {
                'AUTOLOGIN': {
                  'TITULO': '警告',
                  'INFO': '警告\n\n您的會話將關閉，平台將繼續登錄為所選工作中心。\n\n您確認要登錄為選定的工作中心嗎？',
                  'INFOODS': '警告\n\n您的會話將關閉，平台將繼續作為所選公司登錄。\n\n您確認登錄為所選公司嗎？'
                }
              }
            },
            'FOCUS':{
              'MODAL-AUNAUTORIZACION':'尚未授權',
              'BTN-ENTERADO':'輸入',
              'MODAL-AUTORIZACION':'您的調查已發送到驗證',


            },
          }
        },
        'ERRORES': {
          'Ocurrió un error desconocido': '您的計算機或設備與平台的連接失敗，請稍後再嘗試訪問',
          '102': '您輸入的電子郵件未在CultureGO中註冊',
          '103': '密碼不正確',
          'verifyToken_3': '<span>該平台最近進行了更新，因此，為避免丟失信息，我們將關閉您的會話。<br><br>為確保平台的正常運行，<font color ="red">您的瀏覽器將自動更新</font></span>',
          'tokenActLogin': '<span>該平台最近進行了更新，因此並為確保平台正常運行，<font color="red">您的瀏覽器將自動更新</font>，稍後您可以正常訪問該平台</span>',
          'Demo keys out of stock': '調查演示用戶已經筋疲力盡',
          'Keys Out Of Stock': '調查演示用戶已經筋疲力盡',
          'Error: Please Recreate Survey':'在問題中檢測到更改\n\n 要繼續，請重新創建調查',
          'IT Manager Not Found':'電子郵件未發送給IT經理\n\n請輸入電子郵件並手動發送。',
          'NO_PROCC_PROD_ASO':'相關產品目前尚未處理',
          'ERR_PROCC_PROD_ACT':'在 SQL 中更新用戶時出錯',
          '300':'輸入的郵箱沒有訪問權限',
        },
        'ELIMINAR':{
          'MENSAJETEXTO1': '<span>確認處置公司 ',
          'MENSAJETEXTO2': ', 在文本框中輸入公司名稱</span>',
          'SALIR': '出口',
          'VALIDAR': '確認公司',
          'ERRORNOMBREEMPRESA': '輸入的公司名稱與要刪除的公司名稱不匹配',
          'MENSAJE': '你確定嗎？\n\n您即將刪除公司 ',
          'CANCELAR': '取消',
          'CONFIRMAR': '是的，刪除',
          'SUCCES': '公司被淘汰',
          'CERRAR': '關'
        }
      }
    }
};
